module.exports = __webpack_public_path__ + "img/gyant_xl_light_grey_ba_detail_rsh2.556bcc86.jpg";